export const campaign = {
  candidate: "Jason Hardcastle",
  committee: "Jason Hardcastle for Galveston City Council District 6",
  office: "Galveston City Council District 6",
  shortOffice: "District 6",
  domain: "votejasonhardcastle.org",
  email: "info@votejasonhardcastle.org",
  electionDay: "Saturday, May 2, 2026",
  contactEndpoint: "https://api.southcoaststrategy.com",
  donateUrl: "https://www.votejasonhardcastle.com/donate",
  paidFor: "Political advertising paid for by Jason Hardcastle for Galveston City Council District 6.",
};